import { render, staticRenderFns } from "./CreateInvitationDialog.vue?vue&type=template&id=34fe2978&scoped=true"
import script from "./CreateInvitationDialog.vue?vue&type=script&lang=js"
export * from "./CreateInvitationDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateInvitationDialog.vue?vue&type=style&index=0&id=34fe2978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fe2978",
  null
  
)

export default component.exports